<template>
  <div style="text-align: center">
    <img :style="`width: 148px;height: 157px;margin-top: ${marginTop? marginTop: '20px'};`"
         src="../../assets/home/qidai.png" alt="">
    <p style="color: #999">敬请期待！</p>
  </div>
</template>

<script>
export default {
  name: "expect",
  props: [
    'marginTop'
  ]
}
</script>

<style scoped>

</style>
